export const locale = {
  lang: 'en',
  data: {
    subscription: {
      header: 'Souscription FARPODQ',
      form: {
        startDate: 'Date de début',
        period: {
          title: 'Periode'
        },
        society: {
          title: 'Société:'
        },
        premium: {
          title: 'Prime',
          table: {
            premiumBaseHeader: 'Prime de base',
            surplusHeader: 'Assurance excédentaire',
            surpremimumHeader: 'Surprime*',
            tpaHeader: 'TPA',
            totalHeader: 'Total',
            selectedHeader: 'Choix',
            mandatoryBaseAssurance: 'Assurance obligatoire de base',
            surplusText: 'En excédent de',
            premiumBaseHeaderWithSurplus: 'Prime de base avec excédentaire',
            subtotalHeader: 'Subtotal',
            primeHeader: 'Prime',
            surpremimumFooter: 'La surprime est liée à votre historique de dossiers de réclamations.'
          }
        },
        surplus: {
          title: 'Assurance excédentaire'
        },
        summary: {
          title: 'Resume de Paiement'
        },
        registrationPayment: {
          title: 'Paiement'
        },
        confirmationPayment: {
          title: 'Confirmation de paiement'
        },
        payment: {
          title: "Avis de cotisation",
          total: "Total",
          paymentError: "Une erreur est survenue lors du paiement",
          noBillsFound: "Aucune facture de subscription trouvée",
          sumOrMonerisError: "Le montant de la facture est incorrect, ou problème avec Moneris",
          reassuranceMessage: "Votre carte n'a pas été débitée. Veuillez réessayer.",
          nameUnderCard: "Nom sur la carte bancaire",
          transactionError: "Transaction refusée.",
          billError: "Il semble y avoir une erreur concernant la facturation. Veuillez contacter l'Ordre",
          amountToPayBefore: 'La somme de ',
          amountToPayAfter: ' sera imputée au compte de la carte de crédit.'
        }
      }
    }
  }
}